<script>
import { mapGetters } from 'vuex';
import saveDataInLocalStorage from '@/utils/saveDataInLocalStorage';

export default {
  name: 'Presets',
  props: {
    env: {
      type: String,
      default: () => 'prod',
      validator: value => {
        return ['prod', 'dev', 'staging'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      selectedPresetIndex: -1,
      isCurrentSlideInPreset: false,
      isEditing: false,
      deletedPresetIds: [],
    };
  },
  computed: {
    ...mapGetters({
      presetData: 'Predictor/getPresetData',
      sliders: 'Predictor/getSliders',
    }),
    outputedPresets() {
      const { presetData, deletedPresetIds } = this;
      return presetData.filter(item => deletedPresetIds.indexOf(item.id) === -1);
    },
  },
  watch: {
    presetData(value) {
      const noPresetData = value.length === 0;
      if (noPresetData) {
        this.isEditing = false;
      }
    },
  },
  mounted() {
    this.fetchPresetData();
    this.setSelectedPresetId();
  },
  methods: {
    setSelectedPresetId() {
      const selectedPresetId = JSON.parse(localStorage.getItem('selected-preset-id'));
      if (selectedPresetId) {
        this.$store.commit('Predictor/SET_SELECTED_PRESET_ID', { id: selectedPresetId });
      }
    },
    fetchPresetData() {
      const { env, $store } = this;
      $store.dispatch('Predictor/fetchPresetData', { env });
    },
    startEditing() {
      this.isEditing = true;
    },
    cancelEditing() {
      this.isEditing = false;
      this.deletedPresetIds = [];
    },
    async saveEditing() {
      const { dispatch } = this.$store;
      this.isEditing = false;
      if (this.deletedPresetIds.length > 0) {
        const { env, deletedPresetIds: presetIds } = this;
        await dispatch('Predictor/deletePresetData', { env, presetIds });
        setTimeout(async () => {
          await dispatch('Predictor/fetchPresetData', { env });
        }, 200);
      }
    },
    deletePreset({ presetId, isCurrentSelectedPreset }) {
      this.deletedPresetIds.push(presetId);
      if (isCurrentSelectedPreset) {
        this.$store.commit('Predictor/SET_SELECTED_PRESET_ID', { id: '' });
      }
    },
    applyPresetList({ selectedPresetId, selectedPresetList }) {
      const { sliders } = this;
      const { commit } = this.$store;
      const updatedSlider = sliders.map(slider => {
        const { key } = slider;
        return {
          ...slider,
          defaultValue: selectedPresetList[key],
        };
      });
      commit('Predictor/SET_SLIDERS', { sliders: updatedSlider });
      commit('Predictor/SET_SELECTED_PRESET_ID', { id: selectedPresetId });
      saveDataInLocalStorage({ itemName: 'selected-preset-id', data: selectedPresetId });
    },
  },
};
</script>

<template>
  <div v-if="presetData.length > 0" :class="[{ 'presets--is-editing': isEditing }, 'presets']">
    <div class="presets__header">
      <div class="presets__header-text">presets</div>
      <button class="presets__header-edit-btn" @click.prevent="startEditing">edit</button>
      <button class="presets__header-cancel-btn" @click.prevent="cancelEditing">cancel</button>
      <button class="presets__header-save-btn" @click.prevent="saveEditing">save</button>
    </div>
    <div class="presets__main">
      <button
        v-for="(list, index) in outputedPresets"
        :class="[list.isSelected === true ? 'presets__list--selected' : '', 'presets__list']"
        :key="`presets-list-${index}`"
        @click.prevent="
          isEditing
            ? deletePreset({ presetId: list.id, isCurrentSelectedPreset: list.isSelected === true })
            : applyPresetList({ selectedPresetId: list.id, selectedPresetList: list })
        "
      >
        {{ list.name }}
        <div class="presets__list-close-icon"></div>
      </button>
    </div>
  </div>
</template>
